<div class="question-sorting-widget">
  <lib-question-hint
    class="animate__animated"
    [ngClass]="animation()"
    [style.animationDelay.ms]="animationDelay()"
    [hint]="'CHAPTERS.drag_each_item_into_correct_folder' | translate">
  </lib-question-hint>

  <div class="question-sorting-widget__container" cdkDropListGroup [ngClass]="orienation()">

    <div class="sorting-widget-buckets">
      <div class="sorting-widget-buckets__grid">
        @for (bucket of bucketsState(); track bucket.id; let i = $index) {
          <div 
            class="animate__animated sorting-bucket" 
            cdkDropList 
            [ngClass]="animation()"
            [style.animationDelay.ms]="animationDelay() + i * 200"
            [cdkDropListData]="{ index: i }" 
            (cdkDropListDropped)="drop($event)"
            (click)="dropSelectedItemToBucket(i)">
            <ng-template cdkDragPlaceholder></ng-template>
            <div class="sorting-bucket__header">
              <lib-question-answer-option-code class="option-code" [index]="i" [numeric]="true"></lib-question-answer-option-code>
              {{ bucket.text }}
            </div>

            <div class="sorting-bucket__body">
              @for (card of bucket.droppedItems; track card.id; let i = $index) {
                <lib-question-option
                  cdkDrag
                  [cdkDragData]="card"
                  cdkDragPreviewClass="sorting-option-drag-preview"
                  theme="square"
                  class="sorting-item-option"
                  [style.zIndex]="bucket.droppedItems?.length - i"
                  [index]="card.index"
                  [text]="card.text"
                  [mediaType]="card.mediaType"
                  [mediaImage]="card.mediaImage">
                </lib-question-option>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="sorting-widget-items" [class.d-none]="readonlyMode() && itemsLeft()?.length === 0">
      <div 
        class="sorting-widget-items__grid" 
        cdkDropList 
        cdkDropListSortingDisabled 
        [cdkDropListEnterPredicate]="canDrop" 
        [cdkDropListData]="{ index: -1 }">
        @if (itemsLeft()?.length === 0) {
          <div class="options-empty">
            <lib-icon icon="check-circle" class="options-empty-icon"></lib-icon>
          </div>
        }

        @for (card of itemsLeft(); track card.id; let i = $index) {
          <lib-question-option
            cdkDrag
            [cdkDragDisabled]="readonlyMode()"
            [cdkDragData]="card"
            [ngClass]="animation()"
            [style.animationDelay.ms]="animationDelay() + i * 200"
            cdkDragPreviewClass="sorting-option-drag-preview"
            theme="square"
            class="animate__animated sorting-item-option"
            [class.selected-item]="i === selectedItemIndex()"
            [index]="card.index"
            [text]="card.text"
            [mediaType]="card.mediaType"
            [mediaImage]="card.mediaImage"
            (click)="setSelectedItemIndex(i)">
            <ng-template cdkDragPlaceholder></ng-template>
          </lib-question-option>
        }
      </div>
    </div>

  </div>
</div>